import {
  CREATE_PRODUCT_TYPE_FULFILLED,
  FETCH_PRODUCT_TYPES_FULFILLED,
  UPDATE_PRODUCT_TYPE_FULFILLED,
} from './actions';

import type { Product } from '@/types/productTypes';


export interface ProductTypesAction {
  type: string;
  payload?: Product | Product[];
}

const productTypesReducer = (state: Product[] = [], action: ProductTypesAction): Product[] => {
  switch (action.type) {
    case CREATE_PRODUCT_TYPE_FULFILLED:
      return [...state, action.payload as Product];
    case FETCH_PRODUCT_TYPES_FULFILLED:
      return action.payload as Product[];
    case UPDATE_PRODUCT_TYPE_FULFILLED: {
      const updated = action.payload as Product;
      return state.map(productType => {
        if (productType.id === updated.id) {
          return updated;
        }
        return productType;
      });
    }
    default:
      return state;
  }
};

export { productTypesReducer };
